/**
 * 页面布局界面
 */
import React from 'react';
import ReactDOM from 'react-dom';
import { Layout, Icon, Menu, Tabs } from 'antd';

import "../../style/common/index.css";
import "../../style/theme/defaultTheme.scss";
import Login from "./Login";

import SiderMenu from './SiderMenu';

import http from '../../axios/http';

import UserPassword from '../console/user/UserPassword';
import Theme from './Theme';
import MessagePanel from './message/MessagePanel'
import { getCookie } from '../../util/theme.js'
import { global_data } from '../ui/auth'

import MenuData from '../../route/menu';
import NotFound from './NotFound';

const { TabPane } = Tabs;
const SubMenu = Menu.SubMenu;
const MenuItemGroup = Menu.ItemGroup;

const { Header, Content } = Layout;

class Index extends React.Component {
  state = {
    collapsed: false,
    visible: false,
    themeVisible: false,
    userInfo: {},
    messageNum: 0,
    messageList: [],
    themeColor: '',
    logotype: '',
    //菜单相关信息
    menus: [],  //菜单信息
    selectedMenu: '', //当前打开的菜单
    //增加同时打开多个菜单
    activeKey: '',
    panes: [],
    height: 0
  };
  constructor(props) {
    super(props);
    this.contentDiv = React.createRef();
    this.headerDiv = React.createRef();
  }
  componentDidMount() {
    this.loadPowerCode();
    //加载用户信息
    this.loadUserInfo();
    this.getNoticeNum();
    this.loadThemeLogo();
    //加载菜单信息
    this.loadMenu();
    this.calculatedAltitude();

  }
  calculatedAltitude = () => {
    let height = document.body.clientHeight - 200
    this.setState({ height: height });

  }

  //加载样式
  loadThemeLogo = () => {
    let themeColor = getCookie('type');
    let logotype = '';
    if (themeColor === 'custom') {
      logotype = 'custom'
    } else {
      logotype = 'other'
    }
    this.setState({
      themeColor: themeColor,
      logotype: logotype
    })
  }

  loadTheme = (path) => {
    let head = document.getElementsByTagName('HEAD').item(0);
    let style = document.createElement('link');
    style.href = path;
    style.rel = 'stylesheet'
    style.type = 'text/css';
    head.appendChild(style);
  }

  //加载用户信息
  loadUserInfo = () => {
    http.post({
      url: '/auth/findUserInfo',
      success: (res) => {
        this.setState({ userInfo: res });
      }
    });
  }
  // 加载用户权限code
  loadPowerCode = () => {
    http.get({
      url: '/auth/findAuthCode',
      success: (res) => {
        global_data.authCode = res;
      }
    })
  }
  //加载菜单信息
  loadMenu = () => {
    http.post({
      url: '/auth/findMenu',
      data: {
        type: 1
      },
      success: (res) => {
        let firstMenuCode = null;
        if (res != null && res.length > 0) {
          if (res[0].subNode != null && res[0].subNode.length > 0) {
            firstMenuCode = res[0]["code"];
            this.refs["siderMenu"].setMenuData(res[0]["subNode"]);
          } else {
            // firstMenuCode = null;
            this.refs["siderMenu"].setMenuData(res);
            res = [];
          }
        }
        this.setState({ menus: res, selectedMenu: firstMenuCode });
      }
    });
  }

  toggle = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
    this.refs["siderMenu"].toggle();
  }

  //退出登录
  logout = () => {
    http.post({
      url: '/logout',
      success: (res) => {
        sessionStorage.setItem("loginStatus", "false");
        ReactDOM.render(<Login />, document.getElementById('root'));
      }
    });
  }


  //修改密码
  changePassword = () => {
    this.showModal();
  }

  //点击触发
  handleClick = e => {
    if (e.key === "logout") {
      this.logout();
    } else if (e.key === "changePasswd") {
      this.changePassword();
    } else if (e.key === "setting") {
      this.showModalTheme();
    } else if (e.key === "largeScreen") {
      // let url = window.documentURI + "chart";
      let url = window.location.origin + "/large/trade";
      window.open(url, "large-trade");
    } else if (e.key === 'message') {
      this.addPanesList("MESSAGE", '消息中心')
      // ReactDOM.render(<MessageIndex />, document.getElementById('content-root'));
    }
  }

  handleMenuChick = e => {
    let menuCode = e.key;
    if (menuCode === "TRADE_LARGE_SCREEN") {
      let url = window.location.origin + "/large/trade";
      window.open(url, "large-trade");
      return;
    }
    if (menuCode === "AUCTION_LARGE_SCREEN") {
      let url = window.location.origin + "/large/auction";
      window.open(url, "large-auction");
      return;
    }
    if (menuCode === this.state.selectedMenu) {
      return;
    }
    let menus = this.state.menus;
    let subNode = [];
    for (let i in menus) {
      if (menus[i].code === menuCode) {
        subNode = menus[i].subNode;
        break;
      }
    }
    this.setState({ selectedMenu: menuCode });
    this.refs["siderMenu"].setMenuData(subNode, 'topMenu');
  }

  showModal = () => {
    this.setState({ visible: true });
  };
  hiddenModal = () => {
    this.setState({ visible: false });
  };
  showModalTheme = () => {
    this.setState({ themeVisible: true });
  };
  hiddenModalTheme = () => {
    this.setState({ themeVisible: false });
  };

  getNoticeNum = () => {
    http.post({
      url: '/findNotice ',
      data: {},
      success: (res) => {
        if(res == null) res = [];
        let num = res.length;
        this.setState({
          messageNum: num,
          messageList: res
        })
      }
    });
  }

  // 主题选择
  onSelTheme = (themeColor, logotype) => {
    document.getElementsByTagName('body')[0].className = themeColor;
    this.setState({
      logotype: logotype
    })
  }
  // 主题保存
  onSave = (themeColor, customColor) => {
    document.cookie = 'type=' + themeColor;
    document.cookie = 'customColor=' + customColor;
    // window.location.reload();
  }
  onChange = activeKey => {
    this.setState({ activeKey });
  };

  onEdit = (targetKey, action) => {
    this[action](targetKey);
  };

  addPanesList = (key, title) => {
    const { panes } = this.state;
    let isAddKey = true;
    for (let i = 0; i < panes.length; i++) {
      if (panes[i].key === key) {
        isAddKey = false;
        this.setState({ activeKey: key });
      }
    }
    if (isAddKey) {
      //if (panes.length < 5) {
        let Dom = MenuData[key];
        Dom = Dom === undefined || Dom == null ? NotFound : Dom["component"];
        panes.push({ title: title, dom: Dom, key: key });
        this.setState({ panes: panes, activeKey: key });
      // } else {
      //   messager.alert('已打开5个窗口，请关闭部分窗口，再打开新窗口', "打开失败", "error");
      // }
    }
  };

  remove = targetKey => {
    let { activeKey } = this.state;
    let lastIndex;
    //const { panes } = this.state;
    //if (panes.length === 1) {
      //messager.alert('至少保留一个窗口', '关闭失败', 'error')
    //} else {
      this.state.panes.forEach((pane, i) => {
        if (pane.key === targetKey) {
          lastIndex = i - 1;
        }
      });
      const panes = this.state.panes.filter(pane => pane.key !== targetKey);
      if (panes.length && activeKey === targetKey) {
        if (lastIndex >= 0) {
          activeKey = panes[lastIndex].key;
        } else {
          activeKey = panes[0].key;
        }
      }
      this.setState({ panes, activeKey });
    //}
  };

  createMenu = () => {
    let doms = [];
    if (this.state.menus) {
      this.state.menus.forEach((item, index) => {
        if (item.code !== "SCREEN") {
          doms.push(<Menu.Item key={item.code}>
            <span className="nav-text">{item.name}</span>
          </Menu.Item>);
        }
      })
    }
    return doms;
  }

  createScreenMenu = () => {
    let doms = "";
    if (this.state.menus) {
      this.state.menus.forEach((item) => {
        if (item.code === "SCREEN") {
          let subNode = [];
          if (item.subNode !== null && item.subNode.length > 0) {
            item.subNode.forEach(data => {
              subNode.push((<Menu.Item
                onClick={this.handleMenuChick}
                key={data.code}>
                <span className="nav-text">{data.name}</span>
              </Menu.Item>));
            });
            doms = (<SubMenu key={item.code}
              className="submenu-title-wrapper"
              style={{ float: "left" }}
              title={<span className="nav-text">{item.name}</span>}>
              {subNode}
            </SubMenu>);
          }
        }
      })
    }
    return doms;
  }

  render() {
    return (
      // <Layout className={'layout-container' + ' ' + this.state.themeColor}>
      <Layout className='layout-container'>
        <Header className="test">
          {(() => {
            switch (this.state.logotype) {
              case "other": return <div className={this.state.collapsed ? 'logo-min' : 'logo'} />;
              case "custom": return <div className={this.state.collapsed ? 'logo-min1' : 'logo1'} />;
              default: return null;
            }
          }
          )()}
          <div style={{ float: "left", height: '100%' }} >
            <div style={{ float: "left", height: '100%' }} >
              <Icon className="menu-trigger"
                type={this.state.collapsed ? 'menu-unfold' : 'menu-fold'}
                onClick={this.toggle}
              />
            </div>
            <Menu
              onClick={this.handleMenuChick}
              selectedKeys={[this.state.selectedMenu]}
              mode="horizontal"
              className="header-menu"
              theme="dark"
              style={{ float: "left" }}
            >
              {this.createMenu()}
            </Menu>
            <div style={{ float: "left", height: '100%' }} >
              <Menu
                mode="horizontal"
                className="header-menu"
                theme="dark"
                style={{ float: "left" }}
              >
                {this.createScreenMenu()}
              </Menu>
            </div>
          </div>
          <div style={{ float: "right", height: '100%' }} >
            <Menu
              onClick={this.handleClick}
              selectedKeys={["logout"]}
              mode="horizontal"
              className="header-menu"
              theme="dark"
            >
              <Menu.Item key="message" className='large-txt' >
                <Icon type="bell" />消息<span style={{ color: '#ff0000' }}>（{this.state.messageNum}）</span>
              </Menu.Item>
              <SubMenu title={<span className="submenu-title-wrapper "><Icon type="user" />{this.state.userInfo.name}</span>}>
                <MenuItemGroup title="用户中心">
                  <Menu.Item key="userInfo">个人信息</Menu.Item>
                  <Menu.Item key="changePasswd">修改密码</Menu.Item>
                </MenuItemGroup>
                <MenuItemGroup title="设置中心">
                  <Menu.Item key="setting">个性设置</Menu.Item>
                </MenuItemGroup>
              </SubMenu>
              {/* <Menu.Item key="largeScreen" className='large-txt' >
                <Icon type="desktop" />大屏展示
              </Menu.Item> */}
              <Menu.Item key="logout">
                <Icon type="logout" />退出
              </Menu.Item>
            </Menu>
            {/* 密码修改 */}
            <UserPassword
              visible={this.state.visible}
              onCancel={this.hiddenModal.bind(this)}
              editData={this.state.editData}
              successCallback={this.logout}
            />
            {/* 主题设置 */}
            <Theme
              visible={this.state.themeVisible}
              onCancel={this.hiddenModalTheme.bind(this)}
              onSelTheme={this.onSelTheme}
              onSave={this.onSave}
            />
          </div>
        </Header>
        <Layout>
          <SiderMenu ref="siderMenu" openMenuPage={this.addPanesList} />
          <Layout style={{ "width": "100%" }}>
            {/* <Content style={{ margin: '24px 16px', padding: 24, background: '#fff', height: '100%' }} id="content-root"> */}
            <Content style={{ margin: '24px 16px' }} id="content-root" ref={this.contentDiv}>
              <Tabs
                hideAdd
                onChange={this.onChange}
                activeKey={this.state.activeKey}
                type="editable-card"
                onEdit={this.onEdit}
              >
                {this.state.panes.map((item, index) => (
                  <TabPane style={{ padding: 24, background: '#fff' }} activeKey={this.state.activeKey} tab={item.title} key={item.key} ref={this.headerDiv}>
                    <div style={{ height: this.state.height }} >
                      <item.dom ></item.dom>
                    </div>
                  </TabPane>
                ))}
              </Tabs>
            </Content>
          </Layout>
        </Layout>
        {/* <Layout.Footer style={{ textAlign: 'center', paddingTop: '0px' }}>
                    版权所有 © 2004-{new Date().getFullYear()} 厦门二手车交易市场有限公司
                  </Layout.Footer> */}
        <MessagePanel messageList={this.state.messageList} />

      </Layout>

    );
  }
}

export default Index;